import { render, staticRenderFns } from "./envelope-detail.vue?vue&type=template&id=64f382f8"
import script from "./envelope-detail.vue?vue&type=script&lang=js"
export * from "./envelope-detail.vue?vue&type=script&lang=js"
import style0 from "./envelope-detail.vue?vue&type=style&index=0&id=64f382f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports